import { Loader } from '@/components/Loader'
import { lazy, Suspense } from 'react'
import { RoutePaths } from './paths'
import { RouteType } from './types'

// const Home = lazy(() => import('@/pages/Home'))
const Login = lazy(() => import('@/pages/Login'))
const ForgotPassword = lazy(() => import('@/pages/ForgotPassword'))
const Failed = lazy(() => import('@/pages/Failed'))
const Success = lazy(() => import('@/pages/Success'))
const Preferences = lazy(() => import('@/pages/Preferences'))

export const ListRoutes = (): RouteType[] => [
  {
    path: RoutePaths.home,
    isPrivate: false,
    element: (
      <Suspense fallback={<Loader />}>
        <Login />
      </Suspense>
    )
  },
  {
    path: RoutePaths.login,
    isPrivate: false,
    element: (
      <Suspense fallback={<Loader />}>
        <Login />
      </Suspense>
    )
  },
  {
    path: RoutePaths.forgotPassword,
    isPrivate: false,
    element: (
      <Suspense fallback={<Loader />}>
        <ForgotPassword />
      </Suspense>
    )
  },
  {
    path: RoutePaths.generic,
    isPrivate: false,
    element: (
      <Suspense fallback={<Loader />}>
        <Failed />
      </Suspense>
    )
  },
  {
    path: RoutePaths.success,
    isPrivate: false,
    element: (
      <Suspense fallback={<Loader />}>
        <Success />
      </Suspense>
    )
  },
  {
    path: RoutePaths.preferences,
    isPrivate: true,
    element: (
      <Suspense fallback={<Loader />}>
        <Preferences />
      </Suspense>
    )
  }
]
